import { Outlet } from 'react-router-dom';

import { OrganizationDashboardNav, Loader } from '@neo.tax/shared';

import { useCompaniesRedirect } from './hooks';

export const Companies = (): React.ReactElement => (
  <Loader useRedirect={useCompaniesRedirect}>
    <OrganizationDashboardNav />
    <Outlet />
  </Loader>
);
